<template>
    <div class="right">
      <div class="title-box">
        <span class="curr">组织机构</span>
      </div>
      <img class="head-img" src="@/assets/img/icon_zuzhi_img.png" alt="">
    </div>
</template>
<script>
export default {
  data() {
    return {
      leftList: [
        '分会概况',
        '分会简介',
        '分会领导',
        '组织机构',
        '分会动态',
        '人才招聘',
      ]
    }

  }
};
</script>
<style lang="less" scoped>
.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  .head-img {
    width: 756px;
    height: 400px;
    margin: 20px auto 51px auto;
    display: block;
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
